// Normalizes an unknown thrown value to a string we can pattern-match against.
// Errors expose `.message`; some paths reject with a bare string; anything else
// carries no usable message text.
export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  return "";
}
